/**
 *  Model used for feedback submittions.
 */
export class FeedbackModel {

  form: HTMLFormElement;
  screenshots: string[];

}
